
import getProjectGetActions from './getProject';
import setProjectGetActions from './setProject';

export * from './getProject';
export * from './setProject';

export function getActions(dispatch) {
    return {
        ...getProjectGetActions(dispatch),
        ...setProjectGetActions(dispatch)
    }
}
